import { useEffect, useState, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

const GIF_DURATION_MS = 3000;

export function AnimatedSplash() {
  const [visible, setVisible] = useState(Capacitor.isNativePlatform());
  const [fading, setFading] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  // Detect current theme
  const isDark = document.documentElement.classList.contains('dark');
  const videoSrc = isDark ? '/splash.gif' : '/splash-light.mp4';
  const isVideo = videoSrc.endsWith('.mp4');

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    // Hide native static splash immediately
    SplashScreen.hide({ fadeOutDuration: 0 });

    const fadeTimer = setTimeout(() => setFading(true), GIF_DURATION_MS);
    const removeTimer = setTimeout(() => setVisible(false), GIF_DURATION_MS + 400);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[99999] bg-white dark:bg-black overflow-hidden transition-opacity duration-400 ${
        fading ? 'opacity-0' : 'opacity-100'
      }`}
    >
      {isVideo ? (
        <video
          ref={videoRef}
          src={videoSrc}
          autoPlay
          muted
          playsInline
          loop={false}
          className="absolute inset-0 w-full h-full object-contain"
        />
      ) : (
        <img
          src={videoSrc}
          alt="Planbase"
          className="absolute inset-0 w-full h-full object-contain"
          draggable={false}
        />
      )}
    </div>
  );
}
